import { inject } from '@angular/core';
import { Observable, tap, throwError } from 'rxjs';
import { IdpModel, IdpSettingsModel, IdpSetupModel } from '../../../models';
import { AuthStore } from '../../../state/auth.store';
import { SsoIdpHttpService } from './sso-idp-http.service';

export interface IdpBaseModel<TIdpSettingsModel extends IdpSettingsModel = IdpSettingsModel> {
  is_default: boolean;
  name: string;
  public_id: string;
  settings: TIdpSettingsModel;
}

export abstract class SsoIdpBaseService<TIdpSettingsModel extends IdpSettingsModel = IdpSettingsModel> {
  protected readonly ssoIdpHttpService = inject(SsoIdpHttpService);
  protected readonly authStore = inject(AuthStore);

  abstract create(idp: IdpBaseModel<TIdpSettingsModel>): Observable<IdpModel>;
  abstract update(idp: IdpBaseModel<TIdpSettingsModel>): Observable<IdpModel>;
  abstract getSetup(): Observable<IdpSetupModel>;

  delete(publicId: string): Observable<void> {
    return this.ssoIdpHttpService.delete(publicId).pipe(
      tap(() => {
        this.authStore.clearSsoIdps();
      }),
    );
  }

  discoverSettings(metadataUrl: string): Observable<IdpSettingsModel> {
    return throwError(() => new Error(`discovering settings not supported for '${metadataUrl}'`));
  }
}
